import React from "react";
import "./App.css";
import { useTranslation } from "react-i18next"; // Import i18next hook
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Master from "./Components/Layout/Master";
import Devices from "./Pages/Devices";
import Dashboard from "./Pages/Dashboard";
import Management from "./Pages/Management";
import Cloud from "./Pages/Cloud";
import DeviceInfo from "./Pages/DeviceInfo";
import DevicesData from "./Pages/DeviceData";
import Top from "./Components/Language";
import Schedule from "./Pages/Schedule";
import LoginScreen from "./Pages/firebaselogin";
import MotorReport from "./Pages/MotorReport";

function App() {
  const { i18n } = useTranslation(); // Access i18n instance to control language
  

  const toggleLanguage = () => {
    // Toggle between languages
    const newLang = i18n.language === "en" ? "he" : "en";
    i18n.changeLanguage(newLang);
  };
  return (
    <>
      <BrowserRouter basename="/">
        <Top toggleLanguage={toggleLanguage} />

        <Routes>
          <Route path="/" element={<LoginScreen />} />

          <Route path="/" element={<Master />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="deviceinfo" element={<DeviceInfo />} />
            <Route path="cloud" element={<Cloud />} />
            <Route path="devices" element={<Devices toggleLanguage={toggleLanguage}/>} />
          </Route>
          <Route
            path="/management"
            element={<Management toggleLanguage={toggleLanguage} />}
          />

          <Route
            path="/devicesdata"
            element={<DevicesData toggleLanguage={toggleLanguage} />}
          />
          <Route
            path="/schedule"
            element={<Schedule toggleLanguage={toggleLanguage} />}
          />
           <Route
            path="/report"
            element={<MotorReport toggleLanguage={toggleLanguage} />}
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
